import { Outlet, useLocation } from "react-router-dom";

import { Header, Footer } from "./components";
import "./styles.scss";
import { useEffect } from "react";

const DefaultLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="default-layout">
      <Header />
      <main className="default-layout-page">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default DefaultLayout;
